import { render } from "./EmptyState.vue?vue&type=template&id=163fe2f7&scoped=true"
import script from "./EmptyState.vue?vue&type=script&lang=js"
export * from "./EmptyState.vue?vue&type=script&lang=js"

import "./EmptyState.vue?vue&type=style&index=0&id=163fe2f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163fe2f7"]])

export default __exports__